import { Layout } from './layout'
import { Section } from './section'
import floatSmile from '../assets/images/float-smile.png'
import styles from '../assets/scss/components/thanks.module.scss'
import globalStyles from '../assets/scss/global.module.scss'
import { useHtmlClass } from '../lib/hooks/use-html-class'
import facebook from '../assets/images/facebook.svg'
import twitter from '../assets/images/twitter.svg'
import whatsapp from '../assets/images/whatsapp.svg'
import email from '../assets/images/email.svg'
import { useEffect } from 'react'

export const Thanks: React.FC = () => {
  useHtmlClass({ className: 'pink' })

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Layout>
      <Section>
        <div className={styles.left}>
          <img alt="" className={styles.floatSmile} src={floatSmile} />
        </div>
        <div className={styles.right}>
          <h1 className={styles.h1}>Thank you</h1>
          <p className={styles.p}>You have successfully entered the Milk &amp; More competition</p>
          <p className={styles.p}>
            Please enjoy 15% off your next order at &nbsp;
            <a href="https://milkandmore.co.uk/" target="_top">
              milkandmore.co.uk
            </a>
            <br />
            Enter <strong>FLOAT15</strong> at checkout*
          </p>
          <div className={styles.share}>Share with your friends</div>
          <div className={styles.socialIcons}>
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https://www.milkandmore.co.uk/name-our-milk-float"
              rel="noreferrer"
              target="_blank">
              <img alt="Facebook" src={facebook} />
            </a>
            |
            <a
              href="https://twitter.com/intent/tweet?url=https://www.milkandmore.co.uk/name-our-milk-float&text=Name%20our%20floats%20for%20the%20chance%20to%20win%20prizes"
              rel="noreferrer"
              target="_blank">
              <img alt="Twitter" src={twitter} />
            </a>
            |
            <a
              href="whatsapp://send?text=https://www.milkandmore.co.uk/name-our-milk-float"
              rel="noreferrer"
              target="_blank">
              <img alt="Whatsapp" src={whatsapp} />
            </a>
            |
            <a
              href="mailto:%7Bemail_address%7D?subject=Name%20our%20floats%20for%20the%20chance%20to%20win%20prizes&body=Help%20us%20name%20our%20electric%20milk%20floats,%20for%20a%20chance%20to%20win.%0Ahttps://www.milkandmore.co.uk/name-our-milk-float"
              rel="noreferrer"
              target="_blank">
              <img alt="Email" src={email} />
            </a>
          </div>
          <a href="https://milkandmore.co.uk/" className={globalStyles.button} target="_top">
            Shop Milk &amp; More
          </a>
          <div className={styles.fact}>
            <h3 className={styles.h3}>Did you know?</h3>
            <p className={styles.p}>Our 500 electric milk floats make nearly half a million deliveries each week.</p>
            <p className={styles.p}>By using electricity we save nearly 2 million litres of diesel a year.</p>
          </div>
          <p className={styles.terms}>
            * For FLOAT15 Terms and Conditions please visit{' '}
            <a href="https://www.milkandmore.co.uk/float15-tac" target="_top">
              https://www.milkandmore.co.uk/float15-tac
            </a>
          </p>
        </div>
      </Section>
    </Layout>
  )
}
